/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jan 07 2025
 **/

import { Configure } from "@/frameworks/libraries";

type CallHistoryType =
	| "OUTGOING_CALL"
	| "MISSED_INCOMING_CALL"
	| "INCOMING_CALL"
	| "MISSED_OUTGOING_CALL"
	| "REJECTED_CALL"
	| undefined;

const validateCallHistoryType = (call: WebServices.GroupCall.Recent.Data["content"][number]): CallHistoryType => {
	// 내가 caller인 경우 => 상대가 받으면 발신, 상대가 못받으면 미착신 발신
	// 내가 callee 인 경우 => 받으면 수신, 못받으면 부재중 통화
	const amICaller = call.caller?.id === Configure.userID;
	const isOtherPickupCall = call.callUsers
		.filter((user) => user.id !== Configure.userID)
		.map((user) => user.callUserStatus)
		.includes("ENDED");
	const didIPickupCall =
		call.callUsers.find((user) => user.user?.id === Configure.userID)?.callUserStatus === "ENDED";
	const isRejectedCall =
		call.callUsers.find((user) => user.user?.id === Configure.userID)?.callUserStatus === "REJECTED";

	if (amICaller && isOtherPickupCall) {
		//발신
		return "OUTGOING_CALL";
	}
	if (amICaller && !isOtherPickupCall) {
		//미착신 (x 아이콘)
		return "MISSED_OUTGOING_CALL";
	}
	if (!amICaller && didIPickupCall) {
		// 수신
		return "INCOMING_CALL";
	}
	if (!amICaller && !didIPickupCall) {
		// 부재중 수신
		return "MISSED_INCOMING_CALL";
	}
	if (amICaller && isRejectedCall) {
		// 거절됨
		return "REJECTED_CALL";
	}
};

function hasCallGatewayClient(data: SwaggerModels.CallUserResponseVO) {
	return data.callGatewayClient !== undefined;
}

export { validateCallHistoryType, hasCallGatewayClient };
